import { ChevronRightIcon, ExpandMoreIcon, Flex, Icon, IconButton, Text } from '@tradener/lumen';

interface NineBoxHeaderProps {
  isCollapsed: boolean;
  collapsibleSectionId: string;
  onToggleCollapse: () => void;
}

function NineBoxHeader({ isCollapsed, collapsibleSectionId, onToggleCollapse }: NineBoxHeaderProps) {
  return (
    <Flex align="center" justify="flex-start" width="full" minW="0" gap="4">
      <Flex align="center" gap="1.5">
        <IconButton
          size="sm"
          variant="ghost"
          colorScheme="gray"
          aria-label="Alternar colapso da matriz"
          aria-controls={collapsibleSectionId}
          aria-expanded={!isCollapsed}
          icon={<Icon as={isCollapsed ? ChevronRightIcon : ExpandMoreIcon} color="gray.500" boxSize="5" />}
          onClick={onToggleCollapse}
        />

        <Text textStyle="body1-semibold" color="gray.500" lineHeight="1" whiteSpace="nowrap">
          Exposição por Rating
        </Text>
      </Flex>
    </Flex>
  );
}

export default NineBoxHeader;
